import React, { useMemo } from "react";
import { IEvidence, ProgramData } from "@interfaces/Interfaces";
import { evidenceAtom } from "@state/State";
import { useRecoilValueLoadable } from "recoil";
import classNames from "classnames";
import { useProgramCycles } from "@hooks/programs/useProgramCycles";

type Props = {
  program?: ProgramData;
  collapse?: boolean;
};

const MedicalImagingDisplay: React.FC<Props> = (props) => {
  const { currentProgramCycle } = useProgramCycles(props.program?.ID ?? "");

  const allEvidence = useRecoilValueLoadable<IEvidence[] | null>(evidenceAtom);

  let programEvidence: IEvidence[] = [];

  if (allEvidence.state === "hasValue" && allEvidence.contents) {
    programEvidence = allEvidence.contents.filter((evidence: IEvidence) => {
      const evidenceJSON = evidence.evidenceJSON;
      const id = evidenceJSON?.programInfo?.programID || "";

      const onHoldReset = evidenceJSON?.OnHoldReset ?? 0;

      return id === props.program?.ID && onHoldReset !== 1 && evidence.draft !== true;
    });
  }

  const medicalImagingEvidence = useMemo(() => {
    const evidenceForCycle = programEvidence.filter(
      (item) => item.evidenceJSON?.programInfo?.programCycle === currentProgramCycle
    );

    const evidenceDefinitions = props.program?.["Evidence Definitions"] ?? [];
    const evidenceDefinition = evidenceDefinitions.find((item) => item.EvidenceSelectionType === "medical-imaging")!;

    return evidenceForCycle.filter(
      (evidence) => evidence.evidenceJSON.programInfo.programEvidenceDefinitionID === evidenceDefinition.ID
    );
  }, [programEvidence, currentProgramCycle]);

  const count = new Set(medicalImagingEvidence).size;

  return (
    <div>
      <div
        className={classNames("flex flex-row items-end mt-1 mb-4", {
          "!mb-0": props.collapse,
        })}
      >
        <div className="text-acc-34px font-acc-700 tracking-[-0.5] leading-none text-green-light-text">{count}</div>
        <div className="text-acc-15px font-acc-700 tracking-default leading-none text-grey-90 mb-1">
          &nbsp;{`Medical imaging request${count !== 1 ? "s" : ""}`}
        </div>
      </div>
    </div>
  );
};

export default MedicalImagingDisplay;
